import { Router } from "@solidjs/router";
import { FileRoutes } from "@solidjs/start/router";
import { ErrorBoundary, Suspense } from "solid-js";
import { MetaProvider } from "@solidjs/meta";
import { UIProvider, VideoWorkbenchProvider, SelectionProvider } from "~/lib/stores";
import ErrorFallback from "~/components/ui/ErrorFallback";
import "./styles/globals.css";

export default function App() {
  return (
    <MetaProvider>
      <UIProvider>
        <VideoWorkbenchProvider>
          <SelectionProvider>
            <ErrorBoundary
              fallback={(err, reset) => (
                <div class="min-h-screen bg-neutral-900">
                  <ErrorFallback error={err} reset={reset} />
                </div>
              )}
            >
              <Router
                root={(props) => (
                  <Suspense fallback={<div class="flex h-screen items-center justify-center">Loading...</div>}>
                    {props.children}
                  </Suspense>
                )}
              >
                <FileRoutes />
              </Router>
            </ErrorBoundary>
          </SelectionProvider>
        </VideoWorkbenchProvider>
      </UIProvider>
    </MetaProvider>
  );
}
